/**
 * Валидирует введённое показание счётчика.
 *
 * Возвращает true если показание корректно, иначе строку с текстом ошибки.
 *
 * Логика учитывает перекрут счётчика через 0: если новое показание меньше
 * предыдущего, но разница больше половины ёмкости барабана — это перекрут,
 * а не ошибка. Аналогично блокируется скачок вперёд больше половины барабана.
 */
export const validateMeterReading = (
  value: number,
  prevValue: number,
  digitCapacity: number
): string | true => {
  if (value < prevValue) {
    const isRollover = Math.abs(prevValue - value) > digitCapacity / 2;

    return isRollover || 'Показание не может быть меньше предыдущего';
  }

  if (value - prevValue > digitCapacity / 2) {
    return 'Слишком большой расход, обратитесь в управляющую организацию';
  }

  return true;
};
